// tsc and the CRA build resolve this `exports` subpath; the eslint node resolver predates it.
// eslint-disable-next-line import/no-unresolved
import { formatDate } from '@hqo/date-time/core';

interface CalendarDateOptions {
  withWeekday?: boolean;
  month?: 'long' | 'short';
}

/**
 * A calendar day rendered in the user's locale — field order, month and weekday names all come from
 * CLDR. `timezone: 'UTC'` because these values are day-anchored (a `YYYY-MM-DD` selection or a
 * registration day): formatting in UTC keeps the day rather than letting the viewer's zone shift it.
 * `withWeekday` leads the headings that show one; `month` picks the long or short month name.
 */
export const formatCalendarDate = (
  value: string | Date,
  locale: string,
  { withWeekday = false, month = 'long' }: CalendarDateOptions = {},
): string =>
  formatDate(value, {
    locale,
    timezone: 'UTC',
    options: {
      ...(withWeekday ? { weekday: 'long' } : {}),
      year: 'numeric',
      month,
      day: 'numeric',
    },
  });
